(function(){
  if (window.__mnlPolishInit) return;
  window.__mnlPolishInit = true;

  // === Helper : detect reduced motion ===
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(_){}

  // === 1. SKIP LINK A11Y ===
  // Injecte un lien "Aller au contenu" caché qui apparait au focus tab (WCAG 2.4.1)
  // V532 : ne PAS injecter si theme.liquid rend déjà ses skip-links (.skip-to-content-link) — sinon 3 skip-links
  //   dans le DOM (audit V520) + FOUC du lien injecté post-load. On garde juste la logique d'assignation #main-content.
  if (!document.querySelector('.mnl-skip-link') && !document.querySelector('.skip-to-content-link')) {
    var skip = document.createElement('a');
    skip.href = '#main-content';
    skip.className = 'mnl-skip-link';
    skip.textContent = MNL_T('header-polish.skip_to_content', '↓ Aller au contenu');
    document.body.insertBefore(skip, document.body.firstChild);
  }
  {
    // Assigne id="main-content" à la 1ère section pertinente (utile pour les skip-links du thème ET injecté)
    var main = document.querySelector('main, [role="main"], section[id], section.shopify-section');
    if (main && !document.getElementById('main-content')) {
      main.id = 'main-content';
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    }
  }

  // === 2. INTERSECTION OBSERVER FADE-IN ===
  if ('IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          observer.unobserve(e.target); // 1× seulement, économie CPU
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px' // déclenche un peu avant le bas du viewport
    });

    function observeNew(){
      // Observe tous les [data-mnl-fade] pas encore visibles
      document.querySelectorAll('[data-mnl-fade]:not(.is-visible)').forEach(function(el){
        observer.observe(el);
      });
    }
    observeNew();

    // Re-observe si DOM change (lazy content, cards injectées en JS)
    if (window.mnlOnDomChange) {
      window.mnlOnDomChange(observeNew, 400);
    }
  } else if (reduceMotion) {
    // Si reduced motion, juste rendre tout visible immédiatement
    document.querySelectorAll('[data-mnl-fade]').forEach(function(el){
      el.classList.add('is-visible');
    });
  }

  // === 3. AUTO-STAGGER pour grids/lists ===
  // Ajoute automatiquement des delays incrémentaux aux items d'un container [data-mnl-stagger]
  function applyStagger(){
    document.querySelectorAll('[data-mnl-stagger]:not([data-mnl-stagger-done])').forEach(function(container){
      container.setAttribute('data-mnl-stagger-done', '1');
      var items = container.children;
      var stepMs = parseInt(container.getAttribute('data-mnl-stagger-step') || '80', 10);
      var maxDelay = parseInt(container.getAttribute('data-mnl-stagger-max') || '500', 10);
      for (var i = 0; i < items.length; i++) {
        var delay = Math.min(maxDelay, i * stepMs);
        items[i].style.transitionDelay = delay + 'ms';
        if (!items[i].hasAttribute('data-mnl-fade')) {
          items[i].setAttribute('data-mnl-fade', '');
        }
      }
    });
  }
  applyStagger();
  if (window.mnlOnDomChange) window.mnlOnDomChange(applyStagger, 400);

  // === 4. AUTO-FADE pour sections principales (zero-config) ===
  // Toutes les sections, cards, h2 reçoivent automatiquement le fadeIn au scroll
  // (sauf si déjà animées via une autre logique)
  function autoFade(){
    var selectors = [
      'section.shopify-section > *:not([data-mnl-fade]):not(header):not(footer)',
      '.mnl-card:not([data-mnl-fade])',
      '.mnl-coll__card:not([data-mnl-fade])',
      '.mnl-pp3__section:not([data-mnl-fade])'
    ];
    // Skip si reduced motion ou pas d'IO
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    selectors.forEach(function(sel){
      try {
        document.querySelectorAll(sel).forEach(function(el){
          // Skip si déjà visible (au-dessus du viewport au load)
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            // Au-dessus du fold : pas de fade, juste visible direct
            return;
          }
          el.setAttribute('data-mnl-fade', '');
          if (observer) observer.observe(el);
        });
      } catch(_){}
    });
  }
  // Délai léger pour ne pas conflit avec d'autres init
  setTimeout(autoFade, 200);

  // === 5. RIPPLE EFFECT sur boutons primary (effet Material clean) ===
  function addRipple(e){
    var btn = e.currentTarget;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (reduceMotion) return;
    var rect = btn.getBoundingClientRect();
    var size = Math.max(rect.width, rect.height) * 1.5;
    var x = e.clientX - rect.left - size / 2;
    var y = e.clientY - rect.top - size / 2;
    var ripple = document.createElement('span');
    ripple.style.cssText = 'position:absolute;left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px;border-radius:50%;background:rgba(255,255,255,.3);pointer-events:none;transform:scale(0);opacity:1;transition:transform .6s cubic-bezier(.4,0,.2,1),opacity .6s ease;z-index:1;';
    if (!btn.style.position || btn.style.position === 'static') btn.style.position = 'relative';
    if (!btn.style.overflow || btn.style.overflow !== 'hidden') btn.style.overflow = 'hidden';
    btn.appendChild(ripple);
    requestAnimationFrame(function(){
      ripple.style.transform = 'scale(1)';
      ripple.style.opacity = '0';
    });
    setTimeout(function(){ if (ripple.parentNode) ripple.parentNode.removeChild(ripple); }, 700);
  }
  // Bind ripple sur tous les boutons CTA primary (auto-detect via classes communes)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.mnl-btn--primary, .mnl-cd__cta, .mnl-ai-formula__btn--primary, .mnl-hd-ctas__main, .mnl-foot__btn--primary, [data-mnl-ripple]');
    if (btn) addRipple({ currentTarget: btn, clientX: e.clientX, clientY: e.clientY });
  });

  // === 6. SMOOTH ANCHOR LINKS (avec offset header) ===
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]:not([href="#"])');
    if (!a) return;
    var href = a.getAttribute('href');
    if (href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    var headerH = 80; // approx header sticky
    var top = target.getBoundingClientRect().top + window.scrollY - headerH;
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    history.replaceState(null, '', href);
    // Focus pour a11y (lecteur écran)
    target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch(_){}
  });

  // === 7. PREVENT DOUBLE-SUBMIT sur tous les forms ===
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (form && form.id === 'mnl-ai-form') return;
    // V907 : le popup de sortie (.mnl-exit__form) gère LUI-MÊME son anti-double-submit (bouton désactivé) + son
    // état de chargement (spinner + « Envoi… »). On l'exempte de cet util global, sinon : (1) le texte du bouton
    // était écrasé par « ... », masquant le spinner ; (2) le bouton était désactivé même après une simple erreur de
    // validation côté popup, ce qui bloquait l'envoi Klaviyo au submit suivant. Klaviyo est idempotent côté liste.
    if (form && form.classList && form.classList.contains('mnl-exit__form')) return;
    // Forms ATC AJAX (action /cart/add) : gérés sans navigation → l'auto-reset 8s laissait le bouton
    // verrouillé entre deux ajouts. On exempte le verrou global (le code panier gère son propre état).
    if (form && form.getAttribute && /\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!form || form.dataset.mnlSubmitted === '1') {
      e.preventDefault();
      return false;
    }
    form.dataset.mnlSubmitted = '1';
    // Disable boutons submit
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function(b){
      if (!b.dataset.mnlOrigText) b.dataset.mnlOrigText = b.textContent || b.value || '';
      var t = b.textContent !== undefined ? 'textContent' : 'value';
      try { b[t] = '...'; } catch(_){}
      b.disabled = true;
    });
    // Auto-reset après 8s (safety si form ne navigue pas)
    setTimeout(function(){
      delete form.dataset.mnlSubmitted;
      form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function(b){
        if (b.dataset.mnlOrigText) {
          var t = b.textContent !== undefined ? 'textContent' : 'value';
          try { b[t] = b.dataset.mnlOrigText; } catch(_){}
          delete b.dataset.mnlOrigText;
        }
        b.disabled = false;
      });
    }, 8000);
  });

  // === 8. TOOLTIP cohérent (data-mnl-tooltip) — déjà existant ailleurs probablement, mais safety net ===
  // Pas réimplémenté ici pour éviter conflit — utilise le système existant.

  // === 9. VAGUE 152 : VIEW TRANSITIONS API (Chrome 111+) ===
  // Permet des transitions de page natives smooth quand le browser le supporte.
  // Graceful fallback sur browsers non-compatibles (Safari ≤17, Firefox) → comportement standard.
  // Active automatiquement pour les liens internes au site (pas externes).
  if ('startViewTransition' in document && !reduceMotion) {
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (e.defaultPrevented || link.hasAttribute('data-mnl-confirm-logout')) return;
      var href = link.getAttribute('href');
      // Skip : externes, ancres, mailto, tel, javascript, target=_blank, download, ctrl/meta/shift click
      if (!href || href[0] === '#' || /^(mailto|tel|javascript|data):/i.test(href)) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return;
      // Vérifie que le lien est interne (même origin)
      try {
        var url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
      } catch (_) { return; }
      // Skip /admin, /checkout, /cart/*, /discount/* (flows critiques où on veut pas d'animation — V961 : /discount applique le code MNL10 puis 302 vers checkout)
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:admin|checkout|cart\/add|cart\/change|discount|account|customer_authentication|customer_identity|challenge)/i.test(new URL(href, location.href).pathname)) return;
      e.preventDefault();
      // Trigger transition
      document.startViewTransition(function() {
        window.location.href = href;
      });
    });
  }

  // === 10. VAGUE 152 : SAVE-DATA HEADER respect (utilisateurs connexion lente) ===
  // Si user a activé "Data Saver" dans son navigateur (Network Information API), on désactive
  // les animations lourdes et autoplay vidéos. Gain perceived perf énorme sur 3G/Edge.
  try {
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      var slowNetwork = conn.saveData === true ||
        conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g';
      if (slowNetwork) {
        document.documentElement.classList.add('mnl-save-data');
        // Pause toutes les videos autoplay
        setTimeout(function() {
          document.querySelectorAll('video[autoplay]').forEach(function(v) {
            try { v.pause(); v.removeAttribute('autoplay'); } catch(_){}
          });
        }, 100);
      }
    }
  } catch(_){}

  // === 11.octies. VAGUE 188 : GLOBAL KEYBOARD SHORTCUT Alt+A → ouvre Coach IA ===
  // Power user feature : raccourci global pour invoquer le Coach IA depuis n'importe quelle page,
  // sans avoir à chercher le bouton . Skip si focus dans input/textarea (évite collision typing).
  document.addEventListener('keydown', function(e){
    // Trigger : Alt+A (Mac compatible aussi)
    if (!e.altKey || e.key.toLowerCase() !== 'a') return;
    // Skip si user tape dans un input/textarea/contenteditable
    var ae = document.activeElement;
    if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
    // Skip si modificateurs supplémentaires (évite collision avec raccourcis browser/extensions)
    if (e.ctrlKey || e.metaKey || e.shiftKey) return;
    e.preventDefault();
    if (typeof window.mnlOpenAI === 'function') {
      window.mnlOpenAI();
      try {
        if (window.mnlToast) window.mnlToast({ icon: '⌨', title: MNL_T('header-polish.coach_shortcut_title', 'Coach IA ouvert'), sub: MNL_T('header-polish.coach_shortcut_sub', 'Raccourci Alt+A · ESC pour fermer'), type: 'info', duration: 2500 });
      } catch(_){}
    } else {
      // Fallback : redirige vers PDP avec ?open=ai si page actuelle n'a pas d'AI
      if (window.MNL_PRODUCT_URL) {
        window.location.href = window.MNL_PRODUCT_URL + (window.MNL_PRODUCT_URL.indexOf('?') > -1 ? '&' : '?') + 'open=ai';
      }
    }
  });

  // === 11.septies. VAGUE 179 : HOME PAGE QUICK REORDER WIDGET ===
  // Pour returning customers : si user a une formula history → widget floating discret
  // sur home page seulement, avec 1-click reorder de la dernière formule.
  // Skip first-time users (pas de history) et nav vers PDP/cart/account (pas pertinent).
  (function _quickReorderHomeWidget(){
    try {
      var path = window.location.pathname;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root)) return;
      if (root === '/' && /^\/fr\/?$/.test(path)) root = '/fr/';
      if (path !== root && path !== root.slice(0, -1) && path !== root + 'index') return;
      if (document.getElementById('mnl-quick-reorder')) return;
      // Lit AI formula history
      var history = [];
      try { history = JSON.parse(localStorage.getItem('mnl-ai-formula-history') || '[]'); } catch(_){}
      if (!Array.isArray(history) || !history.length) return;
      var lastFormula = history[0];
      if (!lastFormula || typeof lastFormula.name !== 'string' || !lastFormula.name.trim()) return;
      // V1092 : encode la formule historisée en ?f=<base64url> — le SEUL canal que loadFromUrl du
      // configurateur sait lire (pattern V822/V851 : l'ancien ?reorder=1&formula=<id> était un PARAM
      // MORT, la PDP s'ouvrait vierge). Mini-portage de mnlFormulaToConfigUrl (mnl-ai-coach V851),
      // auto-suffisant car mnl-ai-coach n'est pas chargé sur la home. Retourne '' si doses absentes.
      var encodeF = function(fx){
        try {
          if (!fx || !fx.actifs || typeof fx.actifs !== 'object') return '';
          // V1135 : bétaïne retirée du produit — plus jamais ré-encodée depuis l'historique IA (11 actifs).
          var NAME_TO_KEY = {'Caféine':'caffeine','L-Théanine':'theanine','L-Tyrosine':'tyrosine','L-Citrulline':'citrulline','Glycérol':'glycerol','Sel rose':'pinksalt','Béta-Alanine':'betaalanine','Taurine':'taurine','Créatine':'creatine','Électrolytes':'electrolytes','Pipérine':'piperine'};
          var KEY_UNIT = {caffeine:'mg',theanine:'mg',tyrosine:'mg',citrulline:'g',glycerol:'g',pinksalt:'mg',betaalanine:'g',taurine:'mg',creatine:'g',electrolytes:'mg',piperine:'mg'};
          var doses = {}, enabled = {}, hasDose = false;
          /* ═══ V1259 (06/08/2026) — CE WIDGET PERDAIT LES DRAPEAUX ET NE CONVERTISSAIT RIEN ═════════
             TROIS défauts, dont deux silencieux :
             (1) `n:0` EN DUR. Le drapeau « sans stimulants » était écrasé à chaque re-commande. Un
                 client qui avait explicitement composé une formule SANS CAFÉINE la voyait revenir
                 AVEC — le configurateur lit `STATE.noStim = !!loaded.n`. C'est un choix de santé
                 (sensibilité, grossesse, tension), pas une préférence de goût.
             (2) `nc` ABSENT. Même histoire pour « créatine déjà consommée à part » (V1071) :
                 `STATE.noCrea = !!loaded.nc`, donc un champ absent remettait la créatine.
             (3) AUCUNE CONVERSION. Les doses de l'historique partaient brutes vers le configurateur,
                 qui les recalait « au cran le plus proche » — c'est-à-dire au cran le plus CHER pour
                 une dose d'ancienne échelle. 9 indices déplacés sur les pots de référence du banc.
             ⚠ NE JAMAIS INVERSER LE SENS DE `nc`. La valeur interne noCrea est encodée telle quelle
               dans les QR déjà imprimés : l'inverser ferait mentir tous les pots en circulation.
               On la LIT et on la RECOPIE, on ne la ré-interprète pas.
             L'historique du Coach ne porte pas de date exploitable ici : on appelle donc la conversion
             sans `ts` (régime « génération inconnue »), qui laisse intacte toute dose encore possible
             aujourd'hui et ne déplace que celles qu'aucune grille actuelle ne peut expliquer. */
          var _TH = window.MNL_DOSE_THEME;
          Object.keys(NAME_TO_KEY).forEach(function(nm){
            var key = NAME_TO_KEY[nm];
            var m = String(fx.actifs[nm] == null ? '' : fx.actifs[nm]).match(/([\d.,]+)\s*(mg|g)?/i);
            var mg = null;
            if (m) { var v = parseFloat(m[1].replace(',', '.')); if (!isNaN(v)) mg = ((m[2] || 'mg').toLowerCase() === 'g') ? v * 1000 : v; }
            if (mg != null && mg > 0) {
              var d = (KEY_UNIT[key] === 'g') ? Math.round(mg / 100) / 10 : Math.round(mg);
              /* Unité du curseur = unité native des grilles du module (g pour citrulline, glycérol,
                 bêta-alanine, créatine). Passer des mg ici écraserait ces quatre-là sur leur dernier
                 cran — piège documenté en tête de mnl-dose-theme.js. */
              if (_TH) { try { d = _TH.convert(key, d); } catch(_e){} }
              doses[key] = d; enabled[key] = true; hasDose = true;
            }
            else { enabled[key] = false; }
          });
          if (!hasDose) return ''; // aucune dose exploitable → le caller bascule sur ?open=picker
          var INT_MAP = {'Doux':'low','Équilibré':'medium','Equilibré':'medium','Hardcore':'high','Intense':'high'};
          var FMT_MAP = {'starter':'starter','standard':'standard','pro':'pro'};
          var fmtClean = String(fx.format || 'Standard').trim().split(/\s+/)[0].toLowerCase();
          /* `n` — REPRIS de l'archive. Le Coach écrit `_noCaffeine` (5 endroits) et `_noStim` (1) :
             on lit les deux, puisque les deux existent. C'est le drapeau qui était écrasé à 0. */
          var _noStim = (fx._noStim || fx._noCaffeine) ? 1 : 0;
          /* `nc` — DÉDUIT DE LA FORMULE ELLE-MÊME, ET C'EST LE SEUL CHOIX HONNÊTE.
             Vérification faite : le Coach n'enregistre JAMAIS de champ `_noCrea` (aucune occurrence
             dans mnl-ai-coach.js.liquid). Ce drapeau est une notion du CONFIGURATEUR (STATE.noCrea,
             V1071 « créatine déjà consommée à part »), que le Coach ne modélise pas. Il n'y a donc
             rien à « préserver » depuis l'historique : la donnée n'a jamais été écrite.
             Or l'omettre n'est pas neutre. Le lecteur fait `STATE.noCrea = !!loaded.nc`, alors que
             l'état initial du configurateur est `noCrea: true` (créatine en OPT-IN depuis la V1206) :
             un champ absent RENVERSE donc le défaut et rouvre la créatine.
             RÈGLE RETENUE : le drapeau suit les doses du MÊME message. La formule rechargée ne
             contient pas de créatine ⇒ nc = 1 (la case reste cochée, l'écran est cohérent avec la
             formule affichée) ; elle en contient ⇒ nc = 0. On ne déclare jamais rien que la formule
             elle-même ne dise déjà.
             ⚠ NE JAMAIS INVERSER LE SENS DE nc : sa valeur est encodée telle quelle dans les QR déjà
               imprimés. nc = 1 veut dire « SANS créatine », et cela ne se renégocie pas ici. */
          var _noCrea = (doses.creatine > 0) ? 0 : 1;
          var compact = {s:'', i:INT_MAP[fx.intensity] || 'medium', f:FMT_MAP[fmtClean] || 'standard', fl:fx.flavor || '', n:_noStim, nc:_noCrea, sb: fx._subscription ? 1 : 0, o:[], nm:fx.name || 'Ma formule', d:doses, e:enabled};
          var json = JSON.stringify(compact);
          if (json.length > 4000) return '';
          var bytes = new TextEncoder().encode(json);
          var binary = '';
          for (var bi = 0; bi < bytes.length; bi++) binary += String.fromCharCode(bytes[bi]);
          return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); // base64url-safe
        } catch(_) { return ''; }
      };

      setTimeout(function(){
        if (document.getElementById('mnl-quick-reorder')) return;
        var widget = document.createElement('details');
        widget.id = 'mnl-quick-reorder';
        widget.innerHTML = '<summary data-mnl-qr-toggle aria-controls="mnl-qr-panel"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 10a8 8 0 1 1 1.2 7M4 4v6h6"/></svg><span data-mnl-qr-label></span><span class="mnl-qr-chevron" aria-hidden="true">↗</span></summary><section id="mnl-qr-panel" class="mnl-qr-panel" aria-labelledby="mnl-qr-title"><div class="mnl-qr-head"><span class="mnl-qr-local"></span><button type="button" class="mnl-qr-dismiss" data-mnl-qr-close>×</button></div><h2 id="mnl-qr-title"></h2><div class="mnl-qr-product"><div class="mnl-qr-picture" aria-hidden="true"><svg viewBox="0 0 100 130" width="90" height="117" fill="none"><rect x="16" y="23" width="68" height="99" rx="14" fill="#fff" stroke="#d8cfbf"/><rect x="15" y="10" width="70" height="23" rx="6" fill="#fff" stroke="#d8cfbf"/><path d="M33 11v20m7-20v20m7-20v20m7-20v20m7-20v20m7-20v20" stroke="#e4ded3"/><path d="M0 0L0 364L48 334L48 100L141 178L233 100L233 257L280 214L280 0L141 116ZM66 146L66 512L107 512L107 263L217 392L217 146L174 183L174 257L105 183ZM130 329L130 512L281 512L249 451L180 451L180 384Z" transform="translate(39 52) scale(.08)" fill="#191a16"/><path d="M31 104h38" stroke="#ff6c31" stroke-width="3"/></svg></div><div class="mnl-qr-info"><h3 class="mnl-qr-name"></h3><dl class="mnl-qr-meta"></dl></div></div><a class="mnl-qr-resume" data-mnl-qr-go><span></span><span aria-hidden="true">↗</span></a><p class="mnl-qr-hint"></p><a class="mnl-qr-browse"></a></section>';
        function text(selector, key, fallback) { widget.querySelector(selector).textContent = MNL_T('header-polish.' + key, fallback); }
        text('[data-mnl-qr-label]', 'qr2_launcher', 'Ma dernière formule');
        text('.mnl-qr-local', 'qr2_local', 'Enregistrée sur cet appareil');
        text('#mnl-qr-title', 'qr2_title', 'On repart sur ta formule ?');
        text('.mnl-qr-browse', 'qr2_browse', 'Toutes mes formules');
        widget.querySelector('[data-mnl-qr-close]').setAttribute('aria-label', MNL_T('header-polish.qr2_reduce', 'Réduire la carte'));
        widget.querySelector('.mnl-qr-name').textContent = String(lastFormula.name || MNL_T('header-polish.qr2_default_name', 'Ma formule')).slice(0, 180);
        var meta = widget.querySelector('.mnl-qr-meta');
        [['format', 'qr2_format', 'Format enregistré'], ['flavor', 'qr2_flavor', 'Saveur enregistrée']].forEach(function(row){
          if (typeof lastFormula[row[0]] !== 'string' || !lastFormula[row[0]].trim()) return;
          var term = document.createElement('dt'), value = document.createElement('dd');
          term.textContent = MNL_T('header-polish.' + row[1], row[2]);
          value.textContent = lastFormula[row[0]].trim().slice(0, 64);
          meta.appendChild(term); meta.appendChild(value);
        });
        var source = document.getElementById('mnl-hd-cart-body');
        var photo = source && source.getAttribute('data-preworkout-image');
        if (photo) {
          try {
            var imageUrl = new URL(photo, window.location.origin);
            if (imageUrl.protocol === 'https:' && (imageUrl.hostname === window.location.hostname || imageUrl.hostname === 'cdn.shopify.com')) {
              imageUrl.searchParams.set('width', '180');
              var image = document.createElement('img');
              image.width = 90; image.height = 117; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async';
              image.src = imageUrl.href;
              image.addEventListener('error', function(){ image.remove(); }, {once:true});
              widget.querySelector('.mnl-qr-picture').appendChild(image);
            }
          } catch(_){}
        }
        var base = root + 'products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
        var encoded = encodeF(lastFormula);
        widget.querySelector('[data-mnl-qr-go]').href = encoded ? base + '?f=' + encoded : base + '?open=picker';
        text('[data-mnl-qr-go] > span', encoded ? 'qr2_resume' : 'qr2_choose', encoded ? 'Reprendre ma formule' : 'Choisir ma formule');
        text('.mnl-qr-hint', encoded ? 'qr2_hint' : 'qr2_old_hint', encoded ? 'Vérifie la composition et le prix dans le configurateur avant d’ajouter au panier.' : 'Cette ancienne formule doit être vérifiée dans le configurateur.');
        widget.querySelector('.mnl-qr-browse').href = root + 'pages/account#formulas';
        var toggle = widget.querySelector('summary');
        function collapse(restoreFocus){
          if (!widget.open) return;
          widget.open = false;
          if (restoreFocus) toggle.focus({preventScroll:true});
        }
        widget.querySelector('[data-mnl-qr-close]').addEventListener('click', function(){ collapse(true); });
        widget.addEventListener('keydown', function(event){
          if (event.key === 'Escape' && widget.open) { event.preventDefault(); event.stopPropagation(); collapse(true); }
        });
        document.addEventListener('pointerdown', function(event){
          if (widget.open && !widget.contains(event.target)) collapse(false);
        }, {passive:true});
        var frame = 0;
        function place(){
          frame = 0;
          if (!widget.isConnected || widget.open) return;
          var rect = toggle.getBoundingClientRect(), height = window.innerHeight;
          if (!rect.width || !rect.height) return;
          var assigned = parseFloat(widget.style.getPropertyValue('--mnl-qr-bottom')) || 16;
          var safe = Math.max(0, (parseFloat(window.getComputedStyle(widget).bottom) || 16) - assigned);
          var obstacles = [];
          document.querySelectorAll('main button, main input, main label, main summary, main [role="button"], #mnl-back-to-top, #mnlGlobalCoachFab').forEach(function(element){
            var r = element.getBoundingClientRect();
            if (r.width > 0 && r.height > 0 && r.height <= 100 && r.bottom > 0 && r.top < height && r.left < rect.right && r.right > rect.left && window.getComputedStyle(element).visibility !== 'hidden') obstacles.push(r);
          });
          var bottom = 16;
          for (var pass = 0; pass < 6; pass++) {
            var old = bottom, lower = height - bottom - safe, upper = lower - rect.height;
            obstacles.forEach(function(r){ if (r.top < lower && r.bottom > upper) bottom = Math.max(bottom, height - r.top + 10 - safe); });
            if (bottom === old) break;
          }
          widget.style.setProperty('--mnl-qr-bottom', Math.min(bottom, Math.max(16, height - rect.height - 100)) + 'px');
        }
        function schedule(){ if (!frame) frame = window.requestAnimationFrame(place); }
        function keyboard(){
          var viewport = window.visualViewport, active = document.activeElement;
          var editing = active && (active.matches('input,textarea,select') || active.isContentEditable);
          widget.toggleAttribute('data-mnl-qr-keyboard', !!(viewport && editing && window.innerHeight - viewport.height > 140));
          schedule();
        }
        widget.addEventListener('toggle', schedule);
        window.addEventListener('scroll', schedule, {passive:true});
        window.addEventListener('resize', keyboard, {passive:true});
        document.addEventListener('transitionend', function(event){
          if (event.target && event.target.closest && event.target.closest('main')) schedule();
        }, {capture:true,passive:true});
        var main = document.querySelector('main');
        if (main && window.MutationObserver) new MutationObserver(schedule).observe(main, {childList:true,subtree:true});
        document.addEventListener('focusin', keyboard);
        document.addEventListener('focusout', keyboard);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', keyboard, {passive:true});
        document.body.appendChild(widget);
        keyboard();
      }, 4000);
    } catch(_){}
  })();

  // === 11.sexies. VAGUE 160 : CART ABANDONMENT RECOVERY BANNER ===
  // Si user revient sur le site (nouvelle session) ET son panier Shopify a des items → rappel discret.
  // Pattern e-commerce conversion : récupère ~15-20% des abandons via simple visual reminder.
  (function _cartAbandonRecovery(){
    try {
      // Skip si pas browser session new (visited dans les 30min → pas un "retour")
      var lastVisitKey = 'mnl-last-visit-ts';
      var lastVisit = parseInt(localStorage.getItem(lastVisitKey) || '0', 10);
      var now = Date.now();
      // Update timestamp à chaque load
      try { localStorage.setItem(lastVisitKey, String(now)); } catch(_){}
      // Skip si dernière visite < 30min (même session active)
      if (lastVisit && (now - lastVisit) < 30 * 60 * 1000) return;
      // Skip si pas vraiment "ancien" — au moins 2h depuis dernière visite pour être "retour"
      if (!lastVisit || (now - lastVisit) < 2 * 60 * 60 * 1000) return;
      // Skip si on est déjà sur cart/checkout/account (pas pertinent)
      var path = window.location.pathname;
      if (/^\/(cart|checkout|account|admin)/.test(path)) return;
      // Skip si déjà notifié dans cette session
      if (sessionStorage.getItem('mnl-cart-recovery-shown')) return;
      // Skip si user a explicitement vidé son panier récemment (flag set par cart.js handlers)
      try {
        var clearedAt = parseInt(localStorage.getItem('mnl-cart-cleared-ts') || '0', 10);
        if (clearedAt && (now - clearedAt) < 24 * 60 * 60 * 1000) return;
      } catch(_){}

      // Fetch /cart.js pour vérifier si items présents (timeout 3s pour pas bloquer)
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var timeoutId = ctrl ? setTimeout(function(){ try { ctrl.abort(); } catch(_){} }, 3000) : null;
      fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        signal: ctrl ? ctrl.signal : undefined,
        headers: { 'Accept': 'application/json' }
      }).then(function(r){
        // Vague 169 P1 fix : guard si edge Shopify renvoie HTML d'erreur (non-JSON)
        if (!r || !r.ok) return null;
        var ct = r.headers && r.headers.get && r.headers.get('content-type');
        if (ct && ct.indexOf('json') === -1) return null;
        return r.json().catch(function(){ return null; });
      }).then(function(cart){
        if (timeoutId) clearTimeout(timeoutId);
        // Vague 169 P1 fix : type guard strict (avant : undefined.item_count → TypeError)
        if (!cart || typeof cart.item_count !== 'number' || cart.item_count < 1) return;
        // Wait 3s engagement page minimum avant d'afficher
        setTimeout(function(){
          if (sessionStorage.getItem('mnl-cart-recovery-shown')) return;
          sessionStorage.setItem('mnl-cart-recovery-shown', '1');

          var totalEur = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
          var itemsCount = cart.item_count;
          var itemsLabel = itemsCount + ' article' + (itemsCount > 1 ? 's' : '');

          var banner = document.createElement('div');
          banner.id = 'mnl-cart-recovery';
          banner.setAttribute('role', 'status');
          banner.setAttribute('aria-live', 'polite');
          // V985c : fond blanc aplat + bordure/ombre orange douce (ex-dégradé + rose magenta)
          banner.style.cssText = 'position:fixed;top:max(90px,env(safe-area-inset-top,90px));right:max(16px,env(safe-area-inset-right,16px));z-index:8200;background:#fff;border:1.5px solid #F7C4AE;border-radius:14px;padding:14px 16px;box-shadow:0 16px 40px rgba(15,23,42,.18),0 4px 12px rgba(232,78,27,.10);font-family:inherit;font-size:13px;font-weight:600;display:flex;align-items:center;gap:12px;max-width:340px;animation:mnl-cart-recover-in .4s cubic-bezier(.34,1.56,.64,1);';
          banner.innerHTML =
            '<span aria-hidden="true" style="font-size:24px;line-height:1;"></span>' +
            '<div style="flex:1;min-width:0;line-height:1.35;">' +
              MNL_T('header-polish.recovery_kicker_html', '<div style="font-weight:800;color:#E84E1B;font-size:11px;letter-spacing:.02em;margin-bottom:2px;text-transform:uppercase;">Panier sauvegardé</div>') + /* V985c : kicker #E84E1B */
              '<div style="font-size:13px;color:#0f172a;"><strong>' + itemsLabel + '</strong> · ' + totalEur + '</div>' +
            '</div>' +
            MNL_T('header-polish.recovery_cta_html', '<a href="/cart" data-mnl-cart-recover-go style="background:#E84E1B;color:#fff;text-decoration:none;padding:8px 14px;border-radius:8px;font-weight:800;font-size:12px;white-space:nowrap;box-shadow:0 4px 12px rgba(232,78,27,.24);">Voir →</a>') + /* V985c : CTA aplat #E84E1B, radius 8px, ombre orange (ex-dégradé + ombre magenta) */
            MNL_T('header-polish.recovery_close_html', '<button type="button" data-mnl-cart-recover-close aria-label="Fermer" style="background:transparent;border:0;color:#94a3b8;font-size:18px;cursor:pointer;padding:4px 8px;line-height:1;font-family:inherit;">×</button>');
          document.body.appendChild(banner);
          if (!document.getElementById('mnl-cart-recover-kfs')) {
            var s = document.createElement('style');
            s.id = 'mnl-cart-recover-kfs';
            s.textContent = '@keyframes mnl-cart-recover-in{from{opacity:0;transform:translateY(-12px) scale(.95);}to{opacity:1;transform:translateY(0) scale(1);}}@keyframes mnl-cart-recover-out{to{opacity:0;transform:translateY(-12px) scale(.95);}}@media(prefers-reduced-motion:reduce){#mnl-cart-recovery{animation:none!important;}}';
            document.head.appendChild(s);
          }
          var dismiss = function(){
            banner.style.animation = 'mnl-cart-recover-out .25s ease forwards';
            setTimeout(function(){ banner.remove(); }, 280);
          };
          // Click "Voir →" → utilise mnlCartOpen si dispo (ouvre drawer), sinon laisse nav vers /cart
          banner.querySelector('[data-mnl-cart-recover-go]').addEventListener('click', function(e){
            if (typeof window.mnlCartOpen === 'function') {
              e.preventDefault();
              try { window.mnlCartOpen(); } catch(_){ window.location.href = '/cart'; }
            }
            dismiss();
          });
          banner.querySelector('[data-mnl-cart-recover-close]').addEventListener('click', dismiss);
          // Auto-dismiss après 14s
          setTimeout(dismiss, 14000);
          // Analytics
          try {
            if (window.gtag) window.gtag('event', 'mnl_cart_recovery_shown', { items: itemsCount, total: totalEur });
            if (window.dataLayer) window.dataLayer.push({ event: 'mnl_cart_recovery_shown', items: itemsCount });
          } catch(_){}
        }, 3000);
      }).catch(function(){ /* silent : pas critique */ });
    } catch(_){}
  })();

  // Bind : set flag mnl-cart-cleared-ts quand l'user vide effectivement son panier (anti-spam recovery)
  document.addEventListener('mnl:cart:mutated', function(e){
    try {
      var url = (e.detail && e.detail.url) || '';
      // /cart/clear ou /cart/update avec quantity=0 → cart vidé manuellement
      if (/\/cart\/clear/.test(url)) {
        localStorage.setItem('mnl-cart-cleared-ts', String(Date.now()));
      }
    } catch(_){}
  });

  // === 11.quinquies. VAGUE 159 : ONBOARDING TOUR FIRST-VISIT (home page only) ===
  // Auto-trigger un tour 5-steps pour first-time visitors sur la home → guide vers les actions clés.
  // Skip si user a déjà vu (localStorage), si pas sur home, ou si user a déjà interagi (scroll/click).
  // Wait 5s engagement minimum pour laisser explorer naturellement.
  (function _autoOnboardingTour(){
    try {
      // V555 : tutoriel d'arrivée DÉSACTIVÉ (demande user) — le tour auto-guidé first-visit ne se lance plus à l'entrée du site.
      //   Pour le ré-activer : retirer le `return;` ci-dessous. window.mnlStartTour reste dispo (déclenchement manuel possible, ex. bouton "revoir le tour").
      return;
      // Skip si déjà fait
      if (localStorage.getItem('mnl-tour-completed')) return;
      // Skip si pas sur home
      var path = window.location.pathname;
      if (path !== '/' && path !== '/index' && path !== '/fr' && path !== '/fr/') return;
      // Skip si pas reduced-motion respect
      if (reduceMotion) {
        try { localStorage.setItem('mnl-tour-completed', '1'); } catch(_){} // mark as done pour pas re-tenter
        return;
      }
      // Skip si dispositif Save-Data
      try {
        var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (conn && (conn.saveData === true || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) return;
      } catch(_){}
      // Track engagement : skip si user interagit avant le tour
      var hasInteracted = false;
      function _markInteract() { hasInteracted = true; }
      // V539 : un clic sur le bandeau cookies (natif Shopify OU custom MNL) ne compte PAS comme "exploration".
      // Avant : accepter/refuser les cookies déclenchait hasInteracted (clic) → le tour était supprimé pour quasi
      // tous les first-timers. Maintenant on ignore ces clics et on garde l'écoute (pas de once) pour capter un VRAI clic contenu ensuite.
      function _markInteractClick(e) {
        if (e && e.target && e.target.closest && e.target.closest('.mnl-cookie, #shopify-pc__banner, .shopify-pc__banner')) return;
        hasInteracted = true;
      }
      window.addEventListener('scroll', _markInteract, { passive: true, once: true });
      window.addEventListener('click', _markInteractClick, { passive: true });
      window.addEventListener('keydown', _markInteract, { passive: true, once: true });

      /* Vague 170 P1 fix : retry polling si mnlStartTour pas dispo
         Avant : skip silencieusement si engine pas chargé → tour jamais affiché si mnl-polish charge avant mnl-global
         Maintenant : 3 tentatives × 1s (=4-6-8s total au lieu de juste 6s) */
      function _tryTrigger(attempt) {
        if (hasInteracted) return; // user explore déjà, ne pas interrompre
        if (localStorage.getItem('mnl-tour-completed')) return; // re-check au cas où
        if (typeof window.mnlStartTour !== 'function') {
          if (attempt < 3) {
            setTimeout(function(){ _tryTrigger(attempt + 1); }, 1000);
            return;
          }
          // 3 tentatives échouées : engine vraiment absent, abandon silencieux
          try { localStorage.setItem('mnl-tour-completed', '1'); } catch(_){}
          return;
        }
        _doFire();
      }
      var _tourCookieWaits = 0;
      function _cookieBannerVisible(){
        try {
          var sels = ['.mnl-cookie.is-visible', '#shopify-pc__banner', '.shopify-pc__banner__dialog'];
          for (var i = 0; i < sels.length; i++) {
            var el = document.querySelector(sels[i]); if (!el) continue;
            var s = getComputedStyle(el), r = el.getBoundingClientRect();
            if (s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity) > 0 && r.width > 0 && r.height > 0) return true;
          }
        } catch (_) {}
        return false;
      }
      function _doFire(){
        if (hasInteracted) return;
        if (typeof window.mnlStartTour !== 'function') return;
        if (localStorage.getItem('mnl-tour-completed')) return;
        // V539 : ne pas empiler le tour par-dessus le bandeau cookies — consentement d'abord, tour ensuite.
        // Attente bornée (~30s : 20 × 1.5s) puis abandon silencieux si le bandeau est toujours là (re-tentera au prochain pageview).
        if (_cookieBannerVisible()) {
          if (_tourCookieWaits++ < 20) setTimeout(_doFire, 1500);
          return;
        }

        // Construit les steps selon sélecteurs disponibles (graceful skip si target manquant)
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
        var steps = [];

        // Step 1 : hero CTA (Configurer ma formule)
        if (document.querySelector('.mnl-hh__cta')) {
          steps.push({
            target: '.mnl-hh__cta',
            title: MNL_T('header-polish.tour_s1_title', 'Bienvenue chez MyNutriLab'),
            msg: MNL_T('header-polish.tour_s1_msg_html', 'Vous allez pouvoir <strong>configurer votre formule pré-workout sur-mesure</strong> en 60 secondes — 11 actifs cliniques dosés au mg près pour votre profil.')
          });
        }

        // Step 2 : Coach IA trigger (desktop : floating coach FAB, mobile : bnav coach btn)
        var coachSelector = isMobile ? '.mnl-bnav__btn--coach' : '.mnl-global-coach-fab, [data-mnl-ai-open]';
        if (document.querySelector(coachSelector)) {
          steps.push({
            target: coachSelector,
            title: MNL_T('header-polish.tour_s2_title', 'Coach IA'),
            msg: MNL_T('header-polish.tour_s2_msg', 'Discutez avec notre coach IA : quelques questions rapides et il calibre votre formule au mg près selon votre sport, votre poids et votre tolérance.')
          });
        }

        // Step 3 : Cart icon
        if (document.querySelector('#mnl-hd-cart-btn')) {
          steps.push({
            target: '#mnl-hd-cart-btn',
            title: MNL_T('header-polish.tour_s3_title', 'Votre panier'),
            // V356 : "expédition aujourd'hui" FAUX (fabrication sur-mesure 48h, V337). Reformulé "fabrication lancée" cohérent V356 sweep.
            msg: MNL_T('header-polish.tour_s3_msg_html', 'Votre panier est sauvegardé. <strong>Point relais offert dès 49€</strong> · préparation sous 4 jours ouvrés après paiement, puis délai de transport supplémentaire.')
          });
        }

        // Step 4 (mobile only) : bnav
        if (isMobile && document.querySelector('.mnl-bnav')) {
          steps.push({
            target: '.mnl-bnav',
            title: MNL_T('header-polish.tour_s4_title', 'Navigation rapide'),
            msg: MNL_T('header-polish.tour_s4_msg', 'Accès en 1 tap à l\'accueil, recherche, coach IA, panier et compte — toujours en bas de votre écran.')
          });
        }

        // Step 5 : footer trust
        if (document.querySelector('.mnl-foot__trust')) {
          steps.push({
            target: '.mnl-foot__trust',
            title: MNL_T('header-polish.tour_s5_title', 'Paiement & confiance'),
            // V516
            msg: MNL_T('header-polish.tour_s5_msg_html', 'Paiement <strong>SSL chiffré 3D-Secure</strong> (Visa / MC / AMEX / PayPal / Apple/Google Pay). Marque française, conforme DGCCRF. Garantie légale (produit défectueux remplacé).')
          });
        }

        if (steps.length >= 2) {
          try { window.mnlStartTour(steps); } catch(_){}
        } else {
          // Pas assez de targets dispo → marque comme fait sans afficher
          try { localStorage.setItem('mnl-tour-completed', '1'); } catch(_){}
        }
      }
      // Trigger initial après 6s engagement minimum
      setTimeout(function(){ _tryTrigger(0); }, 6000);
    } catch(_){}
  })();

  // === 11.quater. VAGUE 157 : QUIZ ABANDONMENT RECOVERY BANNER ===
  // Si user a un Coach IA quiz en cours (>2 messages, <24h) ET qu'il est sur une AUTRE page
  // que la PDP/configurateur où le Coach IA est intégré → bannière discrète "Reprendre ton quiz ?"
  // Auto-hide après 12s. Click → ouvre l'overlay AI (resumeConversation gère la suite).
  (function _quizAbandonRecovery(){
    try {
      // Skip si on est sur la PDP V3 ou le configurateur (Coach IA déjà accessible inline)
      if (document.querySelector('.mnl-pp3') || document.querySelector('.mnl-pw')) return;
      // Skip si AI overlay déjà actif (user vient juste d'arriver)
      if (document.body.classList.contains('mnl-ai-open')) return;
      // Skip si user a déjà été averti dans cette session
      if (sessionStorage.getItem('mnl-quiz-recovery-shown')) return;

      var raw = localStorage.getItem('mnl-ai-conversation');
      if (!raw) return;
      var data = null;
      try { data = JSON.parse(raw); } catch(_){ return; }
      var ts = parseInt(localStorage.getItem('mnl-ai-conversation-ts') || (data && data.ts) || '0', 10);
      // Skip si > 24h (loadConversation va l'expirer de toute façon)
      if (!ts || Date.now() - ts > 24 * 60 * 60 * 1000) return;
      // Skip si pas assez de messages pour être un "vrai" quiz en cours
      var conv = (data && data.conversation) || [];
      var userMsgs = conv.filter(function(m){ return m && m.role === 'user'; });
      if (userMsgs.length < 2) return;
      // Skip si formule déjà générée (window._mnlAiLastFormula serait set, mais cette flag est en mémoire seulement)
      // Heuristique : check last assistant message for "[FORMULE]" marker
      var lastAssistant = conv.filter(function(m){ return m && m.role === 'assistant'; }).pop();
      if (lastAssistant && /\[FORMULE\]|formule personnalis/i.test(lastAssistant.content || '')) return;

      // Wait 4s d'engagement page avant d'afficher (évite intrusion immédiate)
      setTimeout(function(){
        if (document.body.classList.contains('mnl-ai-open')) return; // user a peut-être ouvert entre temps
        if (sessionStorage.getItem('mnl-quiz-recovery-shown')) return;
        sessionStorage.setItem('mnl-quiz-recovery-shown', '1');

        var banner = document.createElement('div');
        banner.id = 'mnl-quiz-recovery';
        banner.setAttribute('role', 'status');
        banner.setAttribute('aria-live', 'polite');
        // V985c : panneau sombre aplat #101418 (ex-dégradé indigo) + bordure/ombre orange (ex-rose magenta)
        banner.style.cssText = 'position:fixed;bottom:max(20px,env(safe-area-inset-bottom,20px));left:max(16px,env(safe-area-inset-left,16px));z-index:8200;background:#101418;color:#fff;border:1px solid rgba(232,78,27,.3);border-radius:14px;padding:14px 16px;box-shadow:0 16px 40px rgba(0,0,0,.3),0 4px 12px rgba(232,78,27,.2);font-family:inherit;font-size:13px;font-weight:600;display:flex;align-items:center;gap:12px;max-width:340px;animation:mnl-recover-in .4s cubic-bezier(.34,1.56,.64,1);';
        banner.innerHTML =
          '<span aria-hidden="true" style="font-size:22px;line-height:1;"></span>' +
          '<div style="flex:1;min-width:0;line-height:1.35;">' +
            MNL_T('header-polish.quiz_recovery_kicker_html', '<div style="font-weight:800;color:#FF7847;font-size:12px;letter-spacing:.02em;margin-bottom:2px;">QUIZ EN COURS</div>') + /* V985c : orange lumineux sur sombre (ex-ambre #fbbf24) */
            '<div style="font-size:12px;color:rgba(255,255,255,.85);">' + userMsgs.length + ' question' + (userMsgs.length > 1 ? 's' : '') + ' répondues — Reprendre ?</div>' +
          '</div>' +
          MNL_T('header-polish.quiz_recovery_cta_html', '<button type="button" data-mnl-recover-go style="background:#E84E1B;color:#fff;border:0;padding:8px 14px;border-radius:8px;font-weight:800;font-size:12px;cursor:pointer;font-family:inherit;white-space:nowrap;box-shadow:0 4px 12px rgba(232,78,27,.24);">Reprendre →</button>') + /* V985c : CTA aplat #E84E1B, radius 8px, ombre orange (ex-dégradé + ombre magenta) */
          MNL_T('header-polish.quiz_recovery_close_html', '<button type="button" data-mnl-recover-close aria-label="Fermer" style="background:transparent;border:0;color:rgba(255,255,255,.5);font-size:18px;cursor:pointer;padding:4px 8px;line-height:1;font-family:inherit;">×</button>');
        document.body.appendChild(banner);
        // Inject keyframes 1× si manquantes
        if (!document.getElementById('mnl-recover-kfs')) {
          var s = document.createElement('style');
          s.id = 'mnl-recover-kfs';
          s.textContent = '@keyframes mnl-recover-in{from{opacity:0;transform:translateY(20px) scale(.95);}to{opacity:1;transform:translateY(0) scale(1);}}@keyframes mnl-recover-out{to{opacity:0;transform:translateY(20px) scale(.95);}}@media (prefers-reduced-motion: reduce){#mnl-quiz-recovery{animation:none!important;}}';
          document.head.appendChild(s);
        }
        var dismiss = function() {
          banner.style.animation = 'mnl-recover-out .25s ease forwards';
          setTimeout(function(){ banner.remove(); }, 280);
        };
        banner.querySelector('[data-mnl-recover-go]').addEventListener('click', function(){
          if (typeof window.mnlOpenAI === 'function') window.mnlOpenAI();
          dismiss();
        });
        banner.querySelector('[data-mnl-recover-close]').addEventListener('click', dismiss);
        // Auto-dismiss 12s
        setTimeout(dismiss, 12000);
      }, 4000);
    } catch(_){}
  })();

  // === 11.ter. VAGUE 154 : LINK PREFETCH ON HOVER/TOUCH (instant navigation feel) ===
  // Prefetch les pages internes au hover desktop ou touchstart mobile.
  // ~100-300ms gagné perceptiblement sur chaque navigation (page déjà cachée quand user click).
  // Respecte Save-Data (skip si user a Data Saver activé) + reduceMotion (skip si user veut moins d'anim).
  (function(){
    if (reduceMotion) return; // skip si user préfère reduced motion
    try {
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && (conn.saveData === true || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) return;
    } catch(_){}

    var prefetched = new Set();
    var MAX_PREFETCH = 30; // cap pour éviter bloat memory
    var SKIP_PATHS = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|account|admin|api|customer_authentication|customer_identity|challenge|policies|discount|pages\/account)/i;

    function _prefetch(href) {
      if (!href || prefetched.size >= MAX_PREFETCH) return;
      try {
        var url = new URL(href, location.href);
        if (url.origin !== location.origin) return;
        if (SKIP_PATHS.test(url.pathname)) return;
        if (url.pathname === location.pathname) return; // skip self
        var key = url.pathname + url.search;
        if (prefetched.has(key)) return;
        prefetched.add(key);
        // Injection <link rel="prefetch"> — browser handle async + idle priority
        var link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url.href;
        link.as = 'document';
        document.head.appendChild(link);
      } catch(_){}
    }

    var hoverTimer = null;
    document.addEventListener('mouseover', function(e){
      var a = e.target.closest('a[href]');
      if (!a || a.hasAttribute('data-mnl-confirm-logout') || a.hasAttribute('data-no-prefetch')) return;
      if (hoverTimer) clearTimeout(hoverTimer);
      // Debounce 80ms : évite prefetch sur les "fly-over" rapides
      hoverTimer = setTimeout(function(){ _prefetch(a.getAttribute('href')); }, 80);
    }, { passive: true });
    document.addEventListener('mouseout', function(){
      if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
    }, { passive: true });

    // Mobile : touchstart prefetch (user a confirmé son intention de tap, ~200ms avant click)
    document.addEventListener('touchstart', function(e){
      var a = e.target.closest('a[href]');
      if (a && !a.hasAttribute('data-mnl-confirm-logout') && !a.hasAttribute('data-no-prefetch')) _prefetch(a.getAttribute('href'));
    }, { passive: true });
  })();

  // === 11.bis. VAGUE 153 : AUTO-FORMAT INPUTS FR (téléphone + code postal) ===
  // Applique formatting automatique sur input pour les champs FR :
  //   - <input type="tel"> : XX XX XX XX XX (format mobile/fixe FR)
  //   - <input data-mnl-format="postal-fr"> : 5 chiffres uniquement, cap à 5
  //   - <input data-mnl-format="phone-fr"> : alias type=tel
  function _autoFormatPhoneFR(input) {
    if (input.dataset.mnlPhoneFmtBound) return;
    input.dataset.mnlPhoneFmtBound = '1';
    input.setAttribute('inputmode', 'tel');
    input.setAttribute('autocomplete', 'tel');
    input.setAttribute('placeholder', input.placeholder || MNL_T('header-polish.phone_placeholder_fr', '06 12 34 56 78'));
    input.addEventListener('input', function(e) {
      var val = input.value.replace(/\D/g, '').slice(0, 10); // garde max 10 chiffres
      // Groupes de 2 séparés par espaces : 06 12 34 56 78
      var formatted = val.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
      if (input.value !== formatted) {
        var pos = input.selectionStart;
        input.value = formatted;
        // Restaure la position du curseur intelligemment (compense les espaces ajoutés)
        try { input.setSelectionRange(formatted.length, formatted.length); } catch(_){}
      }
      // Validation visuelle : rouge si !== 10 chiffres après start de saisie
      if (val.length > 0 && val.length < 10) input.classList.add('is-incomplete');
      else input.classList.remove('is-incomplete');
    });
    input.addEventListener('blur', function() {
      var digits = input.value.replace(/\D/g, '');
      // Valide format FR : 10 chiffres, commence par 01-09
      if (digits.length === 10 && /^0[1-9]/.test(digits)) {
        input.classList.remove('is-incomplete', 'is-invalid');
        input.classList.add('is-valid');
      } else if (digits.length > 0) {
        input.classList.add('is-invalid');
        input.classList.remove('is-valid');
      } else {
        input.classList.remove('is-valid', 'is-invalid', 'is-incomplete');
      }
    });
  }
  function _autoFormatPostalFR(input) {
    if (input.dataset.mnlPostalFmtBound) return;
    input.dataset.mnlPostalFmtBound = '1';
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'postal-code');
    input.setAttribute('maxlength', '5');
    input.setAttribute('pattern', '[0-9]{5}');
    input.setAttribute('placeholder', input.placeholder || MNL_T('header-polish.postal_placeholder_fr', '75001'));
    input.addEventListener('input', function() {
      var val = input.value.replace(/\D/g, '').slice(0, 5);
      if (input.value !== val) input.value = val;
      if (val.length === 5) input.classList.add('is-valid');
      else input.classList.remove('is-valid');
    });
  }
  function _bindAutoFormat() {
    document.querySelectorAll('input[type="tel"], input[data-mnl-format="phone-fr"]').forEach(_autoFormatPhoneFR);
    document.querySelectorAll('input[data-mnl-format="postal-fr"], input[autocomplete="postal-code"]:not([data-mnl-format])').forEach(_autoFormatPostalFR);
  }
  _bindAutoFormat();
  // Re-bind sur DOM changes (drawer cart, modales, etc.)
  if (typeof window.mnlOnDomChange === 'function') {
    window.mnlOnDomChange(_bindAutoFormat, 350);
  }

  // === 11. VAGUE 152 : COPY-TO-CLIPBOARD utility avec toast feedback ===
  // Capture les éléments [data-mnl-copy] (text à copier dans data-mnl-copy ou textContent)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-mnl-copy]');
    if (!btn) return;
    e.preventDefault();
    var text = btn.dataset.mnlCopy || btn.textContent.trim();
    if (!text) return;
    var done = function() {
      // Feedback visuel : ✓ pendant 1.5s
      var orig = btn.innerHTML;
      btn.innerHTML = MNL_T('header-polish.copy_done_html', '<span style="display:inline-flex;align-items:center;gap:4px;"><span aria-hidden="true">✓</span> Copié</span>');
      btn.classList.add('is-copied');
      setTimeout(function() {
        btn.innerHTML = orig;
        btn.classList.remove('is-copied');
      }, 1500);
      // Toast si dispo
      if (typeof window.mnlToast === 'function') {
        window.mnlToast({ icon: '✓', title: MNL_T('header-polish.copy_toast_title', 'Copié dans le presse-papier'), type: 'success', duration: 2000 });
      }
      // Haptic léger
      try { if (navigator.vibrate) navigator.vibrate(20); } catch(_){}
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function(){
        // Fallback execCommand pour browsers anciens
        try {
          var ta = document.createElement('textarea');
          ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select(); document.execCommand('copy');
          document.body.removeChild(ta); done();
        } catch(_){}
      });
    }
  });
})();

/* ════════ V663 — POLISH UX/UI : reveal-on-scroll (#1) + fondu images (#3) — carte blanche user ════════ */
(function () {
  if (!('IntersectionObserver' in window)) return;
  try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (_) {}
  function init() {
    var vh = window.innerHeight || 800;
    /* #1 — blocs de contenu SOUS la fold montent en fondu. Exclu : accueil scroll-story (.mnl-hflow) ET page
       produit (.mnl-pp3) qui ont DÉJÀ leur propre système d'animation → le reveal ne tourne que sur les pages
       contenu sans système propre (lab, comparateur, engagements, histoire…). */
    if (!document.querySelector('.mnl-hflow') && !document.querySelector('.mnl-pp3')) {
      var revSel = '[data-mnl-reveal], main [class*="-pillar"]:not([class*="-pillars"]), main [class*="__pillar"], main [class*="-persona"]:not([class*="-personas"]), main [class*="__persona"], main [class*="__fact"], main [class*="__study"], main [class*="__metric"], main [class*="__cert"]:not([class*="certs"]), main [class*="__step"]:not([class*="steps"]), main [class*="__article"]';
      var revEls = [].slice.call(document.querySelectorAll(revSel)).filter(function (el) {
        /* exclut les éléments qui ont DÉJÀ leur propre système d'animation (ex: PDP .mnl-pp3-anim) → pas de double-anim */
        var cn = (el.className && el.className.baseVal != null) ? el.className.baseVal : ('' + (el.className || ''));
        return cn.indexOf('anim') === -1 && !(el.closest && el.closest('.mnl-pp3'));
      });
      if (revEls.length) {
        var ioR = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); ioR.unobserve(e.target); } });
        }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
        revEls.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top > vh - 40) { el.classList.add('mnl-reveal'); ioR.observe(el); }  /* sous la fold uniquement */
        });
        /* BULLETPROOF : le CSS n'anime QUE .mnl-reveal.is-in (keyframe). Sans .is-in, l'élément reste VISIBLE
           par défaut → impossible qu'un bloc reste invisible si l'IntersectionObserver ne se déclenche pas. */
      }
    }
    /* #3 — fondu des images lazy au chargement (seulement celles pas encore chargées → zéro flash) */
    document.querySelectorAll('main img[loading="lazy"]').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      img.classList.add('mnl-fade-img');
      var done = function () { img.classList.add('is-loaded'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ════════════════════════════════════════════════════════════════════════════════
   V1233 (03/08/2026) — publie --mnl-bottombar-h : hauteur RÉELLE de la barre basse
   ════════════════════════════════════════════════════════════════════════════════
   DÉFAUT MESURÉ (harnais Chrome 375x812, configurateur ouvert) : la bannière cookies
   (.mnl-cookie__box, y 665→812) recouvrait 100 % de la barre collante du configurateur
   (.mnl-sticky-atc, y 751→812) — barre qui porte LE prix et LE bouton « Suivant ».
   elementFromPoint() au centre du bouton renvoyait « mnl-cookie__btn--accept ».
   RÔLE DE CE BLOC : mesurer la hauteur effective de la barre basse visible (getBoundingClientRect,
   donc safe-area et wrapping inclus) et la publier en variable CSS sur <html>. mnl-polish.css
   s'en sert pour remonter la bannière d'exactement cette hauteur.
   POURQUOI UNE MESURE ET PAS UNE CONSTANTE : la barre du configurateur passe en 2 lignes selon
   l'étape (bouton « Voir ma formule » masqué au récap) et le home-indicator iOS ajoute une
   hauteur variable — toute constante serait fausse sur une partie du parc.
   SÉCURITÉ : la variable vaut « 0px » dès qu'aucune barre n'est visible → le CSS retombe sur
   margin-bottom:0 et le rendu est celui d'avant. Si ce bloc ne tourne pas, la variable n'existe
   pas et le CSS applique son repli :has() (78px). Aucun cas où la bannière peut être cachée. */
/* V1255 (06/08/2026) — ce même bloc publie aussi --mnl-toast-bottom : la pile de
   notifications se pose AU-DESSUS de la carte du bandeau cookies au lieu de lui passer par
   dessus. Voir le pavé correspondant dans mnl-polish.css pour le défaut traité. Les deux
   mesures vivent dans la MÊME fonction apply() volontairement : la position de la carte
   dépend de --mnl-bottombar-h, donc la carte doit être lue APRÈS l'écriture de cette
   variable. Deux blocs séparés ne garantiraient pas cet ordre. */
(function () {
  var SEL = '.mnl-sticky-atc.is-visible, .mnl-pp3-sticky.is-visible';
  var last = null;
  /* V1255 : valeurs de référence de la pile de toasts. TOAST_BASE = la valeur historique de
     mnl-global.css l.855 — tant que rien n'occupe le bas, on la republie à l'identique. */
  var TOAST_BASE = 90, TOAST_GAP = 12, TOAST_ROOM = 150, lastToast = null;

  function visibleBottomBarHeight() {
    var h = 0;
    /* V1233 s'arrêtait ici au-dessus de 980px, au motif que la variable n'était consommée que
       sous cette borne. V1255 : ce n'est plus vrai, et ce ne l'était déjà plus dans les faits.
       MESURÉ AU HARNAIS (1280x800 puis 1472x900, bandeau + barre collante à l'écran) : la carte
       du bandeau recouvrait la barre sur 27 972 px² — le prix et le bouton d'ajout au panier
       étaient dessous. Les deux barres sont `position:fixed; bottom:0` à TOUTE largeur
       (preworkout-configurator-v2.css l.1162, preworkout-product-page-v3.css l.685) et le
       desktop les montre par IntersectionObserver (preworkout-configurator-v2.js l.431 :
       « desktop : visibilité gérée par l'IntersectionObserver »).
       On mesure donc à toute largeur. Le desktop ne paie rien pour autant : sans barre visible
       la fonction renvoie 0 comme avant, et la marge posée par le CSS vaut alors 0px. */
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs;
      try { cs = getComputedStyle(el); } catch (_) { continue; }
      /* on ne retient que ce qui est réellement à l'écran et ancré en bas */
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      if (cs.position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (!r.height || !r.width) continue;
      /* la barre est-elle posée sur le bas du viewport ? (tolérance 2px d'arrondi) */
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (r.bottom < vh - 2) continue;
      /* hauteur visible seulement : si la barre est encore en cours de translation, on ne
         compte pas la partie sortie de l'écran */
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visible > h) h = visible;
    }
    return Math.round(h);
  }

  /* V1255 — hauteur réservée depuis le BAS du viewport par la carte du bandeau cookies.
     On mesure le haut de la CARTE (.mnl-cookie__box) et non celui du conteneur : le conteneur
     .mnl-cookie fait tout l'écran (inset:0) et ne dirait rien. Le rect de la carte porte déjà
     sa marge basse V1233, la barre collante est donc comptée sans avoir à l'additionner.
     Renvoie 0 dès qu'aucun bandeau n'est à l'écran. */
  function cookieReserve() {
    var box = document.querySelector('.mnl-cookie.is-visible .mnl-cookie__box');
    if (!box) return 0;
    var host = box.parentNode;
    /* Fermeture : mnl-global.js pose `style.opacity = '0'` puis retire le nœud 300ms plus tard.
       On lit le style EN LIGNE et pas le style calculé — pendant le fondu, le calculé vaut
       encore ~1 et on garderait la pile en l'air pour rien. */
    try { if (host && host.style && host.style.opacity === '0') return 0; } catch (_) {}
    var cs;
    try { cs = getComputedStyle(box); } catch (_) { return 0; }
    if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
    var r = box.getBoundingClientRect();
    if (!r.height || !r.width) return 0;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    /* pendant l'animation d'entrée (translateY 100% → 0) le haut de la carte est encore sous
       le viewport : la valeur est simplement plus petite, jamais fausse. Un `animationend`
       plus bas déclenche la re-mesure finale. */
    return Math.max(0, Math.round(vh - r.top));
  }

  function apply() {
    var v = visibleBottomBarHeight();
    if (v !== last) {
      last = v;
      /* écriture sur <html> et NON dans <body> : l'observateur de mutations ci-dessous surveille
         l'attribut style du sous-arbre de <body>, écrire ici évite toute boucle de rétroaction. */
      try { document.documentElement.style.setProperty('--mnl-bottombar-h', v + 'px'); } catch (_) {}
    }

    /* V1255 : la pile de toasts se pose au-dessus du plus haut occupant du bas d'écran.
       Lecture faite APRÈS l'écriture ci-dessus → le rect de la carte porte déjà sa marge.
       Aucune boucle possible : --mnl-toast-bottom n'est lue que par .mnl-toast-stack, dont la
       géométrie n'entre dans aucune des deux mesures. */
    var t = TOAST_BASE;
    try {
      /* même borne que la media query qui consomme la variable ; au-dessus la pile repasse en
         haut à droite et ne peut rencontrer personne. */
      if (window.matchMedia('(max-width: 580px)').matches) {
        t = Math.max(TOAST_BASE, v + TOAST_GAP, cookieReserve() + TOAST_GAP);
        /* plafond : il doit toujours rester de quoi afficher un toast entier à l'écran, sinon
           on aurait remplacé un chevauchement par une notification hors champ. */
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (vh > 0) t = Math.min(t, Math.max(TOAST_BASE, vh - TOAST_ROOM));
      }
    } catch (_) {}
    if (t !== lastToast) {
      lastToast = t;
      try { document.documentElement.style.setProperty('--mnl-toast-bottom', t + 'px'); } catch (_) {}
    }
  }

  /* On regroupe les re-mesures dans une frame (lecture de layout après les mutations), MAIS
     requestAnimationFrame est gelé dans un onglet en arrière-plan : mesuré au harnais, un
     redimensionnement laissait la variable sur son ancienne valeur. Un setTimeout de secours
     garantit que la mesure finit toujours par être reprise, même sans frame. */
  var raf = 0, tmo = 0;
  function run() { raf = 0; if (tmo) { clearTimeout(tmo); tmo = 0; } apply(); }
  function schedule() {
    if (!raf) { try { raf = requestAnimationFrame(run); } catch (_) { raf = 0; } }
    if (!tmo) { tmo = setTimeout(function () { tmo = 0; if (raf) { try { cancelAnimationFrame(raf); } catch (_) {} raf = 0; } apply(); }, 150); }
  }

  function start() {
    apply();
    /* la barre apparaît/disparaît via une classe (.is-visible) et sa hauteur change d'étape en
       étape (le bouton « Voir ma formule » est masqué au récap) → on observe les deux. */
    try {
      new MutationObserver(schedule).observe(document.body, {
        subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
      });
    } catch (_) {}
    try {
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(schedule);
        document.querySelectorAll('.mnl-sticky-atc, .mnl-pp3-sticky').forEach(function (el) {
          try { ro.observe(el); } catch (_) {}
        });
      }
    } catch (_) {}
    /* V1255 : le bandeau cookies est AJOUTÉ à <body> puis RETIRÉ — deux mutations de type
       childList, que l'observateur d'attributs ci-dessus ne voit pas. On observe donc aussi
       les enfants DIRECTS de <body> (`subtree` volontairement absent) : le bandeau et la pile
       de toasts y sont posés, les toasts eux-mêmes vont dans la pile et ne déclenchent rien.
       Sans ce garde, la pile restait en l'air après un clic sur Accepter/Refuser. */
    try { new MutationObserver(schedule).observe(document.body, { childList: true }); } catch (_) {}
    try {
      if (window.ResizeObserver) {
        var roc = new ResizeObserver(schedule);
        /* la carte cookies change de hauteur au retournement (texte court ≤520px) */
        document.querySelectorAll('.mnl-cookie__box').forEach(function (el) { try { roc.observe(el); } catch (_) {} });
        /* elle n'existe pas encore au démarrage (posée ~1,8 s après le rendu) : on la prend
           en charge à sa première mesure. */
        var _hookRO = function () {
          var b = document.querySelector('.mnl-cookie__box');
          if (b && !b.__mnlRO) { b.__mnlRO = 1; try { roc.observe(b); } catch (_) {} }
        };
        document.addEventListener('mnl:toastbottom:hook', _hookRO);
        setTimeout(_hookRO, 2000); setTimeout(_hookRO, 4000);
      }
    } catch (_) {}
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    /* la barre est animée (transform .35s) : on re-mesure après la transition d'entrée */
    document.addEventListener('transitionend', function (e) {
      if (e.target && e.target.classList && (e.target.classList.contains('mnl-sticky-atc') || e.target.classList.contains('mnl-pp3-sticky'))) schedule();
    }, true);
    /* V1255 : la carte cookies entre en ANIMATION (mnl-cookie-sheet / mnl-cookie-in), pas en
       transition — `transitionend` ne se déclenche jamais pour elle. Mesurée à mi-course, sa
       hauteur serait sous-évaluée et la pile de toasts retomberait sur ses boutons. */
    document.addEventListener('animationend', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('mnl-cookie__box')) {
        try { document.dispatchEvent(new CustomEvent('mnl:toastbottom:hook')); } catch (_) {}
        schedule();
      }
    }, true);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
